export { default as CreacionTrasladoAlmacen } from "./CreacionTrasladoAlmacen";

